<script setup>
defineProps({ modelValue: { type: Object, required: true }, disabled: Boolean })
const emit = defineEmits(['update:modelValue'])
function update(value, key, event) { emit('update:modelValue', { ...value, [key]: event.target.value }) }
</script>
<template>
  <fieldset :disabled="disabled" class="receipt-fields">
    <legend>收货资料</legend>
    <label>收货人<input :value="modelValue.recipientName" required maxlength="100" autocomplete="shipping name" @input="update(modelValue, 'recipientName', $event)" /></label>
    <label>收货电话<input :value="modelValue.recipientPhone" required maxlength="30" type="tel" autocomplete="shipping tel" @input="update(modelValue, 'recipientPhone', $event)" /></label>
    <label>完整收货地址<textarea :value="modelValue.shippingAddress" required maxlength="500" autocomplete="shipping street-address" @input="update(modelValue, 'shippingAddress', $event)"></textarea></label>
  </fieldset>
</template>
<style scoped>
.receipt-fields { display: grid; gap: 18px; min-width: 0; margin: 16px 0 24px; padding: 0; border: 0; }
legend { margin-bottom: 16px; padding: 0; color: #415570; font-size: 16px; font-weight: 500; }
label { display: grid; gap: 8px; min-width: 0; color: #566b85; font-size: 14px; }
input, textarea { width: 100%; min-height: 44px; padding: 12px; border: 1px solid #cbd8e7; border-radius: 8px; color: #303442; background: #f9fbff; font: inherit; line-height: 1.6; }
textarea { min-height: 104px; resize: vertical; }
input:focus, textarea:focus { outline: 2px solid #80b8e5; outline-offset: 2px; border-color: #1878c9; }
:disabled { cursor: not-allowed; opacity: .65; }
</style>
